import Vue from 'vue'
import ToastComponent from '@/components/Toast.vue'

// 创建Toast构造器
const ToastConstructor = Vue.extend(ToastComponent)

let toastInstance = null

const Toast = {
  show(options) {
    if (!toastInstance) {
      toastInstance = new ToastConstructor()
      toastInstance.$mount(document.createElement('div'))
      document.body.appendChild(toastInstance.$el)
    }
    toastInstance.show(options)
  },
  
  alert(message, onConfirm) {
    this.show({
      message,
      showCancel: false,
      onConfirm
    })
  },
  
  confirm(message, onConfirm, onCancel) {
    this.show({
      message,
      showCancel: true,
      onConfirm,
      onCancel
    })
  }
}

export default Toast
